import { observable, computed, action, reaction } from 'mobx';
import { app } from './../App';
import { debounce, includes } from 'lodash';
import { Search } from './Search';
import { ISearchInputValues, ISearchItemInfo, ISearchItem, ICategoryOrCertificate } from './../../../common/interfaces/search';
import { search, user } from './AllStores';
import { EUserTypeName } from '../../../common/interfaces/user';

// Store
export class CategoriesAndCertification {
    constructor() {
        // Constructor
    }

    private reactToUserChange = reaction(
        () => user.id,
        (id: number) => {
            if (id !== null && user.userType === EUserTypeName.Portal) {
                this.fetchCertificates();
                this.fetchCategories();
            }
        }
    );

    // User info
    @observable public categoriesList: string[] = [];
    @observable public certificationList: string[] = [];

    @observable public categoriesListFromSearch: string[] = [];
    @observable public certificationListFromSearch: string[] = [];

    @observable public filterQuery: string = '';
    @observable public showCategories: boolean = false;

    @computed
    public get categoriesListParsed(): ICategoryOrCertificate[] {
        return this.categoriesList.map(category => {
            return {
                name: category,
                checked: includes(search.searchInputValues.itemGroup, category),
                visible: true,
                crossed: false
            };
        });
    }

    @computed
    public get certificationListParsed(): ICategoryOrCertificate[] {
        return this.certificationList.map(certificate => {
            return {
                name: certificate,
                checked: includes(search.searchInputValues.certCategory, certificate),
                visible: true,
                crossed: false
            };
        });
    }

    @computed
    public get categoriesSearchedResults(): ICategoryOrCertificate[] {
        const query: string = this.filterQuery.toLowerCase().trim();

        return this.categoriesListParsed.map(category => {
            const categoryName = category ? category.name.toLowerCase() : '';
            return {
                ...category,
                visible: category.checked || categoryName.indexOf(query) !== -1,
                crossed: this.categoriesListFromSearch.length > 0 && this.categoriesListFromSearch.indexOf(category.name) === -1
            };
        });
    }

    @computed
    public get certificationSearchedResults(): ICategoryOrCertificate[] {
        const query: string = this.filterQuery.toLowerCase().trim();

        return this.certificationListParsed.map(certificate => {
            const certificateName = certificate ? certificate.name.toLowerCase() : '';
            return {
                ...certificate,
                visible: certificate.checked || certificateName.indexOf(query) !== -1,
                crossed:
                    this.certificationListFromSearch.length > 0 &&
                    this.certificationListFromSearch.indexOf(certificate.name) === -1
            };
        });
    }

    @action
    public fetchCategories = async (): Promise<any> => {
        try {
            const itemGroups = app.service('item-group');
            const categories = (await itemGroups.find()) as string[];

            this.categoriesList = categories;

            return categories;
        } catch (err) {
            console.error(err);
            return err;
        }
    };

    @action
    public fetchCertificates = async (): Promise<any> => {
        try {
            const certificationGroups = app.service('item-certification');
            const certificates = (await certificationGroups.find()) as string[];

            this.certificationList = certificates;

            return certificates;
        } catch (err) {
            console.error(err);
            return err;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/CategoriesAndCertification.ts